var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{key:_vm.urnString,staticClass:"paginator"},[(_vm.urn)?_c('ReaderLink',{attrs:{"urn":_vm.urnString}},[_c('Icon',{attrs:{"name":_vm.icon}})],1):_c('span',{staticClass:"disabled"},[_c('Icon',{attrs:{"name":_vm.icon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }